import { PROVIDER_ERRORS } from "../const";

export default function isIgnorableProviderError(code: unknown): boolean {
  return (
    typeof code === "string" &&
    PROVIDER_ERRORS.includes(code as (typeof PROVIDER_ERRORS)[number])
  );
}
